<template>
   <div class="input-face">
     <AddFace v-if="userInfo.is_face===0" @close="success"/>
     <div v-else class="profile-mod-status">已录入</div>
   </div>
</template>
<script>
import {mapState} from 'vuex'
import AddFace from './addorRecoFace2.vue'
export default {
   name: '',
   components: {
     AddFace
   },
   mixins: [],
   props: {
     
   },
   data() {
     return {
     }
   },
   computed:mapState([
        'userInfo',
    ]),
   watch: {
     
   },
   mounted() {
     
   },
   methods: {
     success(){
        this.userInfo.is_face = 1;
     }
   }
};
</script>
<style lang='scss' scoped>
.input-face{
    width: 100%;
    height: 100%;
    background-color: #fff;
}
</style>